<script>
import create from '../utils/create'
import PivottableUi from '../ts-plottable/PivottableUi'
export default create({
  name: 'plottable-ui',
  mixins: [PivottableUi]
})
</script>
